<template>
    <div class="app-content content devcontent ">
        <div class="content-overlay"></div>
        <div class="header-navbar-shadow"></div>
        <div class="content-wrapper">
            <div class="content-header row">
            </div>
            <div class="content-body">
                <vue-element-loading :active="isLoading" :is-full-screen="true" />
                <section>
                    <div>
                    <div>Map route</div>
                    <div id="floating-panel">
                        <b>Start: </b>
                        <select id="start">
                        <option value="Mumbai">Mumbai</option>
                        <option value="lucknow,UP">
                            lucknow,UP
                        </option>
                        <option value="delhi">
                            delhi
                        </option>
                        <option value="Bhopal ,Madhe Pradesh">
                            Bhopal
                        </option>
                        <option value="surat,gujrat">
                            surat,gujrat
                        </option>
                        </select>
                        <b>End: </b>
                        <select id="end">
                            <option value="surat,gujrat">
                                surat,gujrat
                            </option>
                            <option value="Bhopal ,Madhe Pradesh">
                                Bhopal
                            </option>
                            <option value="lucknow,UP">
                                lucknow,UP
                            </option>
                            <option value="delhi">
                                delhi
                            </option>
                        <option value="253 West 125th Street, New York, NY">
                            Apollo Theater
                        </option>
                        <option value="1 Wall St, New York, NY">Wall St</option>
                        </select>
                    </div>
                    <div id="map"></div>
                    &nbsp;
                    <div id="warnings-panel"></div>
                        <div ref="mapContainer" style="height: 400px;"></div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>
<script>
import VueElementLoading from 'vue-element-loading'
import common_methods from "../../utils/common_methods"
import * as VueGoogleMaps from 'vue2-google-maps';

// Vue.use(VueGoogleMaps, {
//   load: {
//     key: 'AIzaSyB41DRUbKWJHPxaFjMAwdrzWzbVKartNGg',
//     libraries: 'places', // If needed
//   },
// });
export default ({
    name: 'MapRoutes',
    mixins: [common_methods],
    components: {
        VueElementLoading,
    },
    data() {
        return {
            isLoading: false,
            map: null,
            directionsService: null,
            directionsRenderer: null,
        }
    },
    mounted() {
        this.loadGoogleMapsScript().then(() => {
            this.initMap();
        });

        if (!localStorage.getItem('reloaded')) {
            localStorage.setItem('reloaded', '1');
            location.reload();
        }
    },
    methods: {
        loadGoogleMapsScript() {
            console.log("11111111");
            return new Promise((resolve, reject) => {
                const script = document.createElement('script');
                script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDhJQ2sy_EA-1Cin40Hsxph0uKHfDCT_ko&callback=initMap`;
                script.onload = resolve;
                script.onerror = reject;
                document.head.appendChild(script);
            });
        },
        initMap() {
            console.log("2222");

            this.directionsService = new window.google.maps.DirectionsService();
            console.log("this.directionsService", this.directionsService);
            this.directionsRenderer = new window.google.maps.DirectionsRenderer();
            console.log("this.directionsRenderer", this.directionsRenderer);

            const fromCity = { lat: 18.5204, lng: 73.8567 }; // Pune coordinates
            const toCity = { lat: 19.0760, lng: 72.8777 }; // Mumbai coordinates

            document.write('<div id="map-container" style="width:100%;height:400px;"></div>');

            this.createMapInWindow(fromCity, toCity);

            // console.log("this.$refs.mapContainer", this.$refs.mapContainer);
            // this.map = new window.google.maps.Map(this.$refs.mapContainer, {
            //     // center: { lat: 37.7749, lng: -122.4194 },
            //     center: { lat: 18.5204, lng: 73.8567},
            //     zoom: 13,
            // });

            // console.log("this.map", this.map);

            // this.directionsRenderer.setMap(this.map);
        },
        // Your other methods
        // openNewMapWindow() {
        //     console.log("22222");
        //     this.directionsService = new window.google.maps.DirectionsService();
        //     // console.log("this.directionsService", this.directionsService);
        //     this.directionsRenderer = new window.google.maps.DirectionsRenderer();
        //     // console.log("this.directionsRenderer", this.directionsRenderer);

        // },

        createMapInWindow(fromCity, toCity) {
            // const url = `https://www.google.com/maps/dir/?api=1&origin=${fromCity}&destination=${toCity}&travelmode=driving`;
            // window.open(url, '_blank');


            // const directionsService = new window.google.maps.DirectionsService();
            // const directionsRenderer = new window.google.maps.DirectionsRenderer();
            // this.map = new window.google.maps.Map(this.$refs.mapContainer, {
            //     // center: { lat: 37.7749, lng: -122.4194 },
            //     center: { lat: 18.5204, lng: 73.8567},
            //     zoom: 13,
            // });

            console.log("this.map", this.map);
            this.map = new window.google.maps.Map(document.getElementById('map-container'), {
                center: fromCity,
                zoom: 13,
            });
            this.directionsRenderer.setMap(this.map);

            const request = {
                origin: fromCity,
                destination: toCity,
                travelMode: 'DRIVING',
            };

            this.directionsService.route(request, (result, status) => {
                console.log("3333");
                console.log("request", request);
                console.log("result", result);

                if (status === 'OK') {
                    this.directionsRenderer.setDirections(result);
                    console.log("OK");
                } else {
                    console.error('Directions request failed:', status);
                    console.log("Fail", status);
                }
            });
            // Now you can customize the map in the new window as needed
            // For example, you might want to add markers or directions between fromCity and toCity
        },
    },
})
</script>

<style scoped>
.alignment {
    margin-left: 20px;
    margin-bottom: 20px;
}

#map {
    height: 100%;
}

/* 
    * Optional: Makes the sample page fill the window. 
    */
html,
body {
    height: 100%;
    margin: 0;
    padding: 0;
}

#floating-panel {
    position: absolute;
    top: 10px;
    left: 25%;
    z-index: 5;
    background-color: #fff;
    padding: 5px;
    border: 1px solid #999;
    text-align: center;
    font-family: "Roboto", "sans-serif";
    line-height: 30px;
    padding-left: 10px;
}

#warnings-panel {
    width: 100%;
    height: 10%;
    text-align: center;
}
</style>